export default "__VITE_ASSET__5FQ5lRqF__"